// The smallest practice types, in a LEAF module on purpose.
//
// `practicePrefsInput.ts` needs these, and `index.ts` re-exports that file — so
// if the validator imported them from `./index` it would close a cycle whose
// only symptom would be an undefined constant during module init, in a code
// path (a validator) where the failure reads as "every day is invalid".
//
// Nothing in here may import from `./index`.

export const PRACTICE_WEEKDAYS = [1, 2, 3, 4, 5] as const // Mon-Fri
export type PracticeWeekday = 1 | 2 | 3 | 4 | 5
export type PracticePriorityAxis = 'day' | 'field'
